export default __webpack_public_path__ + "static/media/calendar.cf395234.svg";